/**
 * Home / Portal Demo — registry entry.
 *
 * THROWAWAY DEMO CODE. Side-effecting registration (imported once from
 * `@/demo/init`). The home demo is stateless (static fixtures), so it only
 * registers an oRPC client-link resolver — no store/controls. Delete with
 * src/demo/home.
 */

import { registerDemoClientResolver } from '@/demo/core/demo-client';
import { HOME_DEMO_KEY } from './fixtures';
import { homeDemoResolver } from './resolver';

registerDemoClientResolver(HOME_DEMO_KEY, homeDemoResolver);
